import { render, staticRenderFns } from "./midContent.vue?vue&type=template&id=12181e40&scoped=true"
import script from "./midContent.vue?vue&type=script&lang=js"
export * from "./midContent.vue?vue&type=script&lang=js"
import style0 from "./midContent.vue?vue&type=style&index=0&id=12181e40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12181e40",
  null
  
)

export default component.exports